import * as SeparatorPrimitive from '@radix-ui/react-separator'
import clsx from 'clsx'
import * as React from 'react'

import Styles from './Separator.module.scss'

interface ISeparatorProps
  extends React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> {
  variant?: 'solid' | 'squared'
}

const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  ISeparatorProps
>(
  (
    {
      className,
      orientation = 'horizontal',
      variant = 'solid',
      decorative = true,
      ...props
    },
    ref
  ) => (
    <SeparatorPrimitive.Root
      ref={ref}
      decorative={decorative}
      orientation={orientation}
      className={clsx(
        Styles.separator,
        Styles[orientation],
        Styles[variant],
        className
      )}
      data-testid="separator"
      {...props}
    />
  )
)
Separator.displayName = SeparatorPrimitive.Root.displayName

export default Separator
